import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CForm, CTabPane, CFormLabel, CFormSelect, CButton, CRow, CCol, CTable, CTableBody, CTableDataCell, CFormInput, CTableHead, CTableHeaderCell, CTableRow } from '@coreui/react'

const safeParseInsuranceDetails = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}

const InsuranceTab = ({ insuranceList, insuranceTypes, addedInsurances, setAddedInsurances, selectedDetails, Credentialed = true }) => {
  const [selectedInsuranceType, setSelectedInsuranceType] = useState('')
  const [insuranceSubTypes, setInsuranceSubTypes] = useState([])
  const [selectedInsuranceSubType, setSelectedInsuranceSubType] = useState('')
  const [selectedInsuranceID, setSelectedInsuranceID] = useState(-1)
  const [policyNumber, setPolicyNumber] = useState('')
  const [selectedTypeOption, setSelectedTypeOption] = useState(null)
  const [selectedSubTypeOption, setSelectedSubTypeOption] = useState(null)

  // useEffect(() => {

  //   if (selectedDetails && selectedDetails.Insurances && insuranceList.length > 0) {
  //     const insurances = selectedDetails.Insurances.map(insurance => {

  //       let newInsurance = JSON.parse(insurance.InsuranceDetails)
  //       // const matchedInsurance = insuranceList.find(ins => ins.ID == addedInsurances[0].InsuranceID);
  //       return newInsurance
  //     });

  //     setAddedInsurances(insurances[0]);
  //   }
  // }, [selectedDetails, insuranceList]);
  useEffect(() => {
    if (!selectedDetails?.Insurances || insuranceList.length === 0) return

    const insurances = selectedDetails.Insurances.map((insurance) => {
      if (!insurance) return null
      const parsedDetails = safeParseInsuranceDetails(insurance?.InsuranceDetails)

      if (insurance?.ID || insurance?.InsuranceID || insurance?.Type || insurance?.SubType) {
        return {
          ...parsedDetails,
          ...insurance,
          ID: insurance?.ID ?? insurance?.InsuranceID ?? parsedDetails?.ID ?? parsedDetails?.InsuranceID ?? '',
          InsuranceID: insurance?.InsuranceID ?? insurance?.ID ?? parsedDetails?.InsuranceID ?? parsedDetails?.ID ?? '',
          Type: insurance?.Type || parsedDetails?.Type || '',
          SubType: insurance?.SubType || parsedDetails?.SubType || '',
          PolicyNumber: insurance?.PolicyNumber || parsedDetails?.PolicyNumber || parsedDetails?.PolicyNo || '',
          Credentialed:
            insurance?.Credentialed ??
            parsedDetails?.Credentialed ??
            false,
        }
      }

      if (!insurance?.InsuranceDetails) return null

      try {
        return JSON.parse(insurance.InsuranceDetails)
      } catch (error) {
        console.error('Invalid JSON in InsuranceDetails:', insurance.InsuranceDetails)
        return null
      }
    }).filter(Boolean)

    const nextSnapshot = JSON.stringify(insurances)
    const currentSnapshot = JSON.stringify(Array.isArray(addedInsurances) ? addedInsurances : [])

    if (insurances.length > 0 && nextSnapshot !== currentSnapshot) {
      setAddedInsurances(insurances)
    }
  }, [selectedDetails?.Insurances, insuranceList, addedInsurances, setAddedInsurances])

  const handleInsuranceTypeSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedTypeOption(selectedOption)
      setSelectedInsuranceType(selectedOption.value)
      const insurance = insuranceList.filter((ins) => {
        if (ins.Type == selectedOption.value) {
          return ins
        }
      })
      if (insurance) {
        setInsuranceSubTypes(insurance)
      }
      setSelectedSubTypeOption(null)
      setSelectedInsuranceSubType('')
    } else {
      setSelectedTypeOption(null)
      setSelectedInsuranceType('')
      setInsuranceSubTypes([])
      setSelectedSubTypeOption(null)
      setSelectedInsuranceSubType('')
    }
  }

  const handleInsuranceSubTypeSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedSubTypeOption(selectedOption)
      setSelectedInsuranceSubType(selectedOption.value)
      const insurance = insuranceList.filter((ins) => {
        if (ins.Type == selectedInsuranceType) {
          if (ins.SubType == selectedOption.value) return ins
        }
      })

      if (insurance.length > 0) {
        setSelectedInsuranceID(insurance[0].ID)
      }
    } else {
      setSelectedSubTypeOption(null)
      setSelectedInsuranceSubType('')
      setSelectedInsuranceID(-1)
    }
  }
  const handleAddInsurance = () => {
    const newInsurance = {
      ID: selectedInsuranceID,
      Type: selectedInsuranceType,
      SubType: selectedInsuranceSubType,
      Credentialed: false,
      PolicyNumber: policyNumber,
    }

    setAddedInsurances([newInsurance])
    // setAddedInsurances([...addedInsurances, newInsurance]);
    setSelectedInsuranceType('')
    setSelectedInsuranceSubType('')
    setSelectedTypeOption(null)
    setSelectedSubTypeOption(null)
    setPolicyNumber(null)
    setInsuranceSubTypes([])
  }

  const handleInsuranceCheckboxChange = (insuranceID, field, value) => {
    setAddedInsurances((prevInsurances) => prevInsurances.map((ins) => (ins.ID === insuranceID ? { ...ins, [field]: value } : ins)))
  }

  return (
    <CTabPane visible>
      <CForm className="mt-3">
        <CRow className="mb-3">
          <CCol xs="6">
            <CFormLabel>Primary</CFormLabel>
            <Select
              options={insuranceTypes.map((type) => ({
                value: type,
                label: type,
              }))}
              value={selectedTypeOption}
              onChange={handleInsuranceTypeSelect}
              placeholder="Select Primary Insurance"
              isClearable
              className="basic-single-select"
              classNamePrefix="select"
            />
          </CCol>
          <CCol xs="6">
            <CFormLabel>Secondary</CFormLabel>
            <Select
              options={insuranceSubTypes.map((obj) => ({
                value: obj.SubType,
                label: obj.SubType,
              }))}
              value={selectedSubTypeOption}
              onChange={handleInsuranceSubTypeSelect}
              placeholder="Select Secondary Insurance"
              isClearable
              className="basic-single-select"
              classNamePrefix="select"
              isDisabled={!selectedInsuranceType}
            />
          </CCol>
          <CCol xs="6" className="mt-3">
            <CFormLabel>Policy Number</CFormLabel>
            <CFormInput type="text" id="PolicyNumber" name="Policy Number" placeholder="Enter a Policy Number" value={policyNumber} onChange={(e) => setPolicyNumber(e.target.value)} style={{ fontSize: '14px' }} required />
          </CCol>
        </CRow>
        <CRow>
          <CCol xs="12">
            <CButton style={{ backgroundColor: '#1976d2', borderColor: '#1976d2', color: '#fff' }} onClick={handleAddInsurance}>
              Add Insurance
            </CButton>
          </CCol>
        </CRow>
      </CForm>
      {addedInsurances && addedInsurances?.length > 0 && (
        <CTable striped className="mt-3">
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell style={{ color: 'var(--ui-text-primary, #ffffff)' }}>Insurance Type</CTableHeaderCell>
              <CTableHeaderCell style={{ color: 'var(--ui-text-primary, #ffffff)' }}>Insurance SubType</CTableHeaderCell>
              <CTableHeaderCell style={{ color: 'var(--ui-text-primary, #ffffff)' }}>Policy Number</CTableHeaderCell>
              {/* <CTableHeaderCell visible={Credentialed} style={{ visibility: Credentialed }}>
                Credentialed
              </CTableHeaderCell> */}
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {addedInsurances.map((insurance, index) => {
              return (
                <CTableRow key={index}>
                  <CTableDataCell style={{ color: 'var(--ui-text-secondary, #d1d5db)' }}>{insurance.Type}</CTableDataCell>
                  <CTableDataCell style={{ color: 'var(--ui-text-secondary, #d1d5db)' }}>{insurance.SubType}</CTableDataCell>
                  <CTableDataCell style={{ color: 'var(--ui-text-secondary, #d1d5db)' }}>{insurance.PolicyNumber}</CTableDataCell>
                  {/* <CTableDataCell style={{ visibility: Credentialed }}>
                    <input type="checkbox" checked={insurance.Credentialed} onChange={(e) => handleInsuranceCheckboxChange(insurance.ID, 'Credentialed', e.target.checked)} />
                  </CTableDataCell> */}
                </CTableRow>
              )
            })}
          </CTableBody>
        </CTable>
      )}
    </CTabPane>
  )
}

export default InsuranceTab
